
import { Component, Prop, Vue } from "vue-property-decorator";
import { ReportShowConfigV5Item } from "@/lib/model/exam/result";
import { CandidateNewResult } from "@/lib/model/exam/candidate-result";

@Component({})
export default class PaperReportH5Comp14 extends Vue {
  @Prop() index!: number;
  @Prop({ default: () => new CandidateNewResult() }) all!: CandidateNewResult;
  @Prop({ default: () => new ReportShowConfigV5Item() })
  option!: ReportShowConfigV5Item;

  get signatureImgUrl() {
    return this.all.report.signature.imgUrl;
  }

  openImg(url: string) {
    this.$emit("openImg", url);
  }
}
